module.exports = __webpack_public_path__ + "static/media/background.c08ba529.svg";